import { Box, Typography } from "@mui/material";

const TextContainerField = ({ label, value, labelStyle, valueStyle }) => (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', py: 0.5, borderBottom: '1px solid #eee' }}>
      <Typography variant="subtitle2" color="text.secondary" sx={{ fontWeight: '500', ...labelStyle }}>
        {label}
      </Typography>
      <Typography variant="body2" sx={{ fontWeight: '600', ...valueStyle }}>
        {value}
      </Typography>
    </Box>
);

export default TextContainerField